export var schema = {
  title: "Public Liability",
  description: "Public Liability Claim Form",
  type: "object",
  properties: {
    info: {
      type: "object",
      title: "Information",
      required: ["region", "insuredPolicyNumber", "insuredName", "insuredtel", "clientEmail", "brokerage", "brokeremail", "claimtypeCat", "claimtype"],
      properties: {
        region: {
          type: "string",
          title: "Region", 
          enum: ["Gauteng", "Cape Town"]
        },
        insuredPolicyNumber: {
          type: "string",
          title: "Policy Number"
        },
        insuredName: {
          type: "string",
          title: "Insured Name and Surname"
        },
        insuredtel: {
          type: "string",
          title: "Insured Contact Number",
          minLength: 10
        },
        clientEmail: {
          type: "string",
          title: "Insured Email",
          format: "email"
        },
        brokerage: {
          type: "string",
          title: "Brokerage"
        },
        brokerName: {
          type: "string",
          title: "Broker Contact Person"
        },
        brokeremail: {
          type: "string",
          title: "Broker Email",
          format: "email"
        },
        claimtypeCat: {
          type: "string",
          title: "What type of incident you want to submit claim for?",
          enum: ["Motor", "Non-motor"]
        },
        claimtype: {
          type: "string",
          title: "Item you want to submit claim for"
        },
        claimMotor: {
          type: "string",
          title: "Motor item you want to submit claim for",
          enum: ["Motor Vehicle Windscreen", "Vehicle Stolen or Hijacked", "Accident Collision"]
        },
        claimNonMotor: {
          type: "string",
          title: "Non-motor item you want to submit claim for",
          enum: ["Geyser", "Property Loss or Damage", "Public Liability"]
        }
      },
      dependencies: {
        claimMotor: {
          oneOf: [{
            properties: {
              claimMotor: {
                enum: ["Accident Collision"]
              },
              thirdparty: {
                type: "object",
                title: "Third Party",
                required: ["thirdpartyInvolved"],
                properties: {             
                  thirdpartyInvolved: {
                    type: "string",
                    title: "Was there a Third Party Involved in the Incident?",
                    enum: ["Yes", "No"]
                  }
                },
                dependencies: {
                  thirdpartyInvolved: {
                    oneOf: [{
                      properties: {
                        thirdpartyInvolved: {
                          enum: ["Yes"]
                        },
                        thirdpartyOther: {
                          type: "object",
                          title: "",
                          required: ["thirdpartyHaveDetails"],
                          properties: { 
                            thirdpartyHaveDetails: {
                              type: "string",
                              title: "Do you have Third Party Details?",
                              enum: ["Yes", "No"]
                            }
                          },
                          dependencies: {
                            thirdpartyHaveDetails: {
                              oneOf: [{
                                properties: {
                                  thirdpartyHaveDetails: {
                                    enum: ["No"]
                                  },
                                  thirdpartyHaveDetailsNote: {
                                    type: "null",
                                    title: "When you receive third party information, please submit to your broker as it's required for claim processing."
                                  }
                                }
                              }, {
                                properties: {
                                  thirdpartyHaveDetails: {
                                    enum: ["Yes"]
                                  }
                                }   
                              }]
                            }
                          }
                        }
                      }
                    }, {
                      properties: {
                        thirdpartyInvolved: {
                          enum: ["No"]
                        }
                      }   
                    }]
                  }
                }
              }
            }
          }]
        }
      }
    },
    incident: {
      type: "object",
      title: "Incident",
      required: ["insureddateloss","incidentAddress","incidentDescription","incidentisCovered"],
      properties: {
        insureddateloss: {
          title: "Date and Time When Incident Occurred?",
          type: "string",
          format: "date-time"
        },
        incidentAddress: {
          type: "string",
          title: "Address Where Incident Occurred?"
        },
        incidentLat: {
          type: "string",
          title: "Latitude"
        },
        incidentLong: {
          type: "string",
          title: "Longitude"
        },
        incidentDescription: {
          type: "string",
          title: "Description on How Incident Occurred?"
        },
        incidentisCovered: {
          title: "Is this Incident Covered Under Any Other Policy of Insurance?",
          type: "string",
          enum: ["Yes", "No"]
        }
      }
    },
    police: {
      type: "object",
      title: "Police",
      required: ["policeReported"],
      properties: {
        policeReported: {
          type: "string",
          title: "Was the Incident Reported to the Police?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        policeReported: {
          oneOf: [{
            properties: {
              policeReported: {
                enum: ["Yes"]
              },
              reportDetails: {
                type: "object",
                title: "Police Report Details",
                required: ["policePlaceReported", "policeDateReported", "policeCaseNumber"],
                properties: {
                  policePlaceReported: {
                    title: "Police Station Where Incident Reported",
                    type: "string"
                  },
                  policeDateReported: {
                    title: "Date Reported",
                    type: "string",
                    format: "date"
                  },
                  policeCaseNumber: {
                    title: "SAPS Case Number",
                    type: "string"
                  }
                }
              }
            }
          }, {
            properties: {
              policeReported: {
                enum: ["No"]
              },
              reportNote: {
                type: "null",
                title: "Please Report Incident to Police and Update Your Broker."
              }
            }
          }]
        }
      }
    },
    witnesses: {
      type: "object",
      title: "Witnesses",
      properties: {
        witnessList: {
          title: "Witnesses",
          type: "array",
          items: {
            type: "object",
            properties: {
              witness: {
                type: "array",
                title: "Witness",
                items: [{
                  key: "name",
                  type: "string",
                  title: "Name"
                }, {
                  key: "string",
                  type: "string",
                  title: "Contact Number",
                  minLength: 10
                }, {
                  key: "address",
                  type: "string",
                  title: "Address"
                }]
              }
            }
          }
        }
      }
    },
    propertyDamage: {
      type: "object",
      title: "Property Damage",
      required: ["propertyDamageAddress"],
      properties: {
        propertyDamageName: {
          title: "Name of Owner",
          type: "string"
        },
        propertyDamageContactNumber: {
          title: "Contact Number of Owner",
          type: "string",
          minLength: 10
        },
        propertyDamageAddress: {
          type: "object",
          title: "",
          properties: {
            address: {
              type: "string",
              title: "Address of Owner"
            },
            lat: {
              type: "string",
              title: "Latitude"
            },
            long: {
              type: "string",
              title: "Longitude"
            }
          }
        }
      }
    },
    personalInjuries: {
      type: "object",
      title: "Personal Injuries",
      properties: {
        personalInjuriesList: {
          title: "Personal Injuries",
          type: "array",
          items: {
            type: "object",
            properties: {
              person: {
                type: "array",
                title: "Injured Person",
                items: [{
                  key: "name",
                  type: "string",
                  title: "Name"
                }, {
                  key: "contactNumber",
                  type: "string",
                  title: "Contact Number",
                  minLength: 10
                }, {
                  key: "email",
                  type: "string",
                  title: "Contact Email",
                  format: "email"
                }, {
                  key: "idPassportNumber",
                  type: "string",
                  title: "ID/Passport Number"
                }, {
                  key: "age",
                  type: "number",
                  title: "Age"
                }, {
                  key: "relationship",
                  title: "Relationships",
                  description: "If Person Named Above is in your Service, your Tenant, or Related to you. Please Provide Details.",
                  type: "string"
                }]
              }
            }
          }
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      description: "Please Attach Any Correspondence of Claim Made Against You if Any.",
      properties: {
        attachmentsDescription: {
          title: "Description",
          description: "If a claim has been, or is being made against you, give details and attach any correspondence.",
          type: "string"
        },
        attachmentsList: {
          title: "Attachments",
          type: "array",
          description: "File Names Should Not Have Any Round Brackets. ()",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my/our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept Terms and Conditions",
          description: "Tick Box to Accept Terms and Conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};

export var uiSchema = {
  claimMotor: {
    classNames: "hidden"
  },
  claimNonMotor: {
    classNames: "hidden"
  },
  incidentLat: {
    "ui:widget": "hidden"
  },
  incidentLong: {
    "ui:widget": "hidden"
  },
  incidentDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  reportDetails: {
    policePlaceReported: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    }
  },
  propertyDamageAddress: {
    lat: {
      "ui:widget": "hidden"
    },
    long: {
      "ui:widget": "hidden"
    }
  },
  propertyDamageDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  relationshipsDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  attachmentsDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  witnessList: {
    "ui:options": {
      orderable: false
    }
  },
  personalInjuriesList: {
    "ui:options": {
      orderable: false
    }
  }
};